import ApiService from '@/services/core/api.service'

const LiveStockTypeService = {
  async get (query) {
    return ApiService.get(`admin/live-stock-types?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/live-stock-types', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/live-stock-types/${payload.id}`, payload)
  }
}

export default LiveStockTypeService
